import apiClient from './client';

export const assetApi = {
  syncAssets: async () => {
    const response = await apiClient.post('/api/assets/sync');
    return response.data;
  },
  getAssets: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.tradable !== undefined) params.append('tradable', filters.tradable);
    if (filters.exchange) params.append('exchange', filters.exchange);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    
    const response = await apiClient.get(`/api/assets?${params.toString()}`);
    return response.data;
  },
  getAssetStats: async () => {
    const response = await apiClient.get('/api/assets/stats');
    return response.data;
  },
  searchAssets: async (query, limit = 10, tradable = true) => {
    const params = new URLSearchParams();
    params.append('search', query);
    params.append('limit', String(limit));
    if (tradable !== undefined) params.append('tradable', String(tradable));

    const response = await apiClient.get(`/api/assets?${params.toString()}`);
    return response.data;
  },
  getAssetBySymbol: async (symbol) => {
    const response = await apiClient.get(`/api/assets/${encodeURIComponent(symbol)}`);
    return response.data;
  },

  /**
   * Batch company names: { AAPL: "Apple Inc.", ... }
   */
  getNames: async (symbols = []) => {
    const list = [...new Set(
      (symbols || []).map((s) => String(s || '').trim().toUpperCase()).filter(Boolean)
    )];
    if (!list.length) return { success: true, data: {} };
    const params = new URLSearchParams();
    params.append('symbols', list.join(','));
    const response = await apiClient.get(`/api/assets/names?${params.toString()}`);
    return response.data;
  },
};

